import { JsonObject, JsonProperty } from 'json2typescript';

/**
 * 買い物カゴ購入パラメータ
 */
@JsonObject('CartPurchaseParam')
export default class GoodsPurchaseParam {
  constructor() {
    this.cartCode = '';
    this.serialCodes = [];
  }

  @JsonProperty('cart_code')
  public cartCode: string;

  @JsonProperty('serial_codes')
  public serialCodes: string[];
}
